<label class="field-label"><%= I18n.confirmation.labels.visit_type %></label>
<div class="field-input select">
  <select data-appointment-booking-wizard-behaviour="field-input" data-field-input-type="integer" name="validated_visit_type_id">
    <% if (!validated_visit_type) { %>
      <option value="" disabled selected><%= I18n.prompts.visit_type %></option>
    <% } %>
    <% validated_visit_types.forEach(function(visit_type) { %>
      <% if (validated_returning_patient ? visit_type.valid_for_returning_patient : visit_type.valid_for_new_patient) { %>
        <option value="<%= visit_type.id %>" <% if (visit_type.id == validated_visit_type_id) { %>selected<% } %>><%- visit_type.name %></option>
      <% } %>
    <% }) %>
  </select>
</div>
